import React, { Component } from "react";
import {Button} from '@learningblocks/exp-components';
import "./MoreContext.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

export class MoreContext extends Component {

  render() {
    return (
      <div className="modal-section moreContextModal">
        <h3 style={{textAlign: "left"}} className="heading">
          More Context
        </h3>
        <p style={{whiteSpace: "pre-wrap", textAlign: "left"}} className="endDescription">{"In addition to your sample setup, you will also run a series of control reactions.\n\nControls are an important part of an experimental design as they allow you to to determine if your reaction is working correctly."}</p>
        <div style={{display: "flex", flexDirection: "row"}}>
          <div style={{border: "1px solid "+colors.navy2, background: colors.navy5, borderRadius: "5px", padding: "8px"}} >
            <h4 style={{textAlign: "center", margin: "12px 0"}}>Postive control</h4>
            <p style={{whiteSpace: "pre-wrap", textAlign: "center"}}>A positive control is a sample in an experiment that produces a known positive result to compare with the test sample after the same treatment. It is used to confirm that all your reagents work as expected.</p>
          </div>
          <div style={{border: "1px solid "+colors.navy2, background: colors.navy5, marginLeft: "16px", borderRadius: "5px", padding: "8px"}} >
            <h4 style={{textAlign: "center", margin: "12px 0"}}>Negative control</h4>
            <p style={{whiteSpace: "pre-wrap", textAlign: "center"}}>{"The negative control is the opposite of the positive control: the negative control verifies that no response is produced when none is expected after the same treatment. This can help to confirm that there was no contamination of your samples. \n\nAn important precaution is to wear gloves when preparing your reactions as skin cells are easily shed and your own DNA may contaminate your PCR reaction."}</p>
          </div>
        </div>
        <div className="modal-footer">
          <Button className='moreContext' onClick={()=>this.props.showModal(false)}>
           Finished reading
          </Button>
        </div>
      </div>
    );
  }
}
